<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3><small>Available</small> Settings</h3>
          <v-btn-toggle class="pull-right tw--mt-9">
            <v-btn small @click="goTo('/settings/create')" v-if="canCreate" text outlined>Add New</v-btn>
            <v-btn small icon @click="initSettings" :loading="refreshing" title="Load new settings">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-btn-toggle><br>
          <v-card v-for="setting in settings" :key="setting.id" class="mb-1 set-list">
            <v-card-text class="py-0">
              <setting-view :setting="setting" class=""></setting-view>
            </v-card-text>
            <v-card-actions class="py-0">
              <v-icon x-small class="grey--text" role="button" @click="deleteSetting(setting)">{{ icons.delete }}</v-icon>
              <v-spacer></v-spacer>
              <span class="text-muted">Last changed by: <i>{{ setting.user.name }}</i>, {{ moment(setting.updated_at).fromNow() }}</span>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const SettingView = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "settings" */ '@/Components/Settings/setting')

  export default {
    name: 'AllSettings',
    layout,
    props: [
      'settings',
      'canCreate',
    ],
    components: {
      SettingView
    },
    metaInfo () {
      return {
        title: 'Settings',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        refreshing: false,
      }
    },
    methods: {
      initSettings () {
        this.refreshing = true;
        this.$inertia.post('/settings/initialize', {}, {
          onFinish: () => {
            this.refreshing = false
          }
        })
      },
      deleteSetting (setting) {
        this.$inertia.delete('/settings/' + setting.id, {
          preserveScroll: true,
        })
      }
    }
  }
</script>

<style lang="scss">
  .set-list {
    border-bottom: 1px solid !important;
  }
</style>
